<template>
  <div class="container app-details candidate" :set="path = $route.path.split('/')[2]">
    <div class="app-details-top" v-for="candidate in copy.candidates" v-if="candidate.short_name == path">
      <div class="app-details-top-flex">
        <div class="app-details-image">
          <img :src="'./assets/headshots/'+candidate.short_name+'.png'"></img>
        </div>
        <div class="app-details-top-right">
            <h2 class="app-details-name">{{ candidate.name }}</h2>
            <p class="app-details-title">{{ candidate.title }}</p>
            <div class="button button-background-gray" v-if="candidate.plan" v-html="mdInline(candidate.plan)"></div>
            <div class="button button-background-gray" v-if="candidate.higher_ed_plan" v-html="mdInline(candidate.higher_ed_plan)"></div>
            <div class="button button-background-gray" v-if="candidate.tag_page" v-html="mdInline(candidate.tag_page)"></div>
            <!-- <p class="app-details-image-credit" v-html="mdInline(candidate.image_credit)"></p> -->
        </div>
      </div>
      <p class="app-details-image-credit" v-html="mdInline(candidate.image_credit)"></p>
      <div class="app-details-intro">
        <p v-for="(p, index) in candidate.intro" v-html="mdInline(p)"></p>
      </div>
      <!-- <div v-if="candidate.status == 'out'">
        <ul v-for="item in candidate.content">
          <li v-html="md(item.text)"></li>
        </ul>
      </div> -->
      <!-- <div v-else> -->
        <div class="app-issues"
             v-for="issue in copy.issues"
             v-if="issue.candidates">
           <div v-if="issue.candidates.includes(path)">
            <a :href="'./index.html#/issues/'+issue.image_name+'#Toggle'" class="app-details-header"><h4>{{ issue.category }}</h4></a>
            <ul>
              <li v-for="item in candidate.content" v-if="item.category == issue.category" v-html="md(item.text)"></li>
            </ul>
          </div>
        </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
  var md = require("markdown-it")();
  module.exports = {
    props: ['copy'],
    methods: {
      md: function(input) {
        return md.render(input);
      },
      mdInline: function(input) {
        return md.renderInline(input);
      }
    },
  }
</script>

<style scoped>

</style>
